import axios from 'axios'
import Global from '../Global'
import { sessionHeader } from './main.api';
import { CPUtils } from '../Utils';

export default class ChannelApi {
    constructor(){}

    static createChannel(activeChannel_cp_id, purpos){
        let data = {
            "channel_id": activeChannel_cp_id, //adatan existing folder id (check /api/folder/root)
            "channel_purpose": purpos // (optional) a string describing the channels purpose
        }
        return axios
        .post(Global.GetAPIURL() + '/channel/create', JSON.stringify(data), sessionHeader).catch(function(err) {
            if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static createDirect(other_user){
        let data = {
            "other_user_id": other_user, //adatan existing folder id (check /api/folder/root)
        }

        if(CPUtils.hasEmail(other_user)){
            data = {
                "other_user_mail": other_user, //adatan existing folder id (check /api/folder/root)
            }
        }

        return axios
        .post(Global.GetAPIURL() + '/channel/create', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static getMyChannels(){
        return axios
        .get(Global.GetAPIURL() + '/channel/my', sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static getNodes(channel_id){
        let data = {
            "channel_id": channel_id
        }
        return axios
        .post(Global.GetAPIURL() + '/channel/nodes', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }


    static channelDetails(channel_cp_id){
        var data = {
          "channel_id": channel_cp_id,
        }
        return axios
        .post(Global.GetAPIURL() + '/channel/details', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
      }
    static inviteUser(data){
        return axios
        .post(Global.GetAPIURL() + '/channel/invite_user', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }
    static deleteInviteUser(data){
        return axios
        .post(Global.GetAPIURL() + '/channel/invite_delete', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })   //@TODO refactor
    }
    static acceptInvit(channel_doc){
        let invitation_id
        if(typeof channel_doc.invitation_id != 'undefined'){
            invitation_id = channel_doc.invitation_id
        }
        else if(channel_doc.direct && typeof channel_doc.invitations != 'undefined' && channel_doc.invitations.length > 0){
            invitation_id = channel_doc.invitations[0].invitation_id
        }

        let data = {
            "invite_id": invitation_id
        }
        return axios
        .post(Global.GetAPIURL() + '/channel/invite_accept', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }
    /**
     * decline invitation of current channel
     */
    static declineInvit(channel_doc){
        let invitation_id
        if(typeof channel_doc.invitation_id != 'undefined'){
            invitation_id = channel_doc.invitation_id
        }
        else if(channel_doc.direct && typeof channel_doc.invitations != 'undefined' && channel_doc.invitations.length > 0){
            invitation_id = channel_doc.invitations[0].invitation_id
        }
        let data = {
            "invite_id": invitation_id
        }
        return axios
        .post(Global.GetAPIURL() + '/channel/invite_delete', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }
    /**
     * leave active channel
     */
    static leaveActiveChannel(channel_id){
        let data = {
          "channel_id": channel_id
       }
       return axios
       .post(Global.GetAPIURL() + '/channel/leave', JSON.stringify(data), sessionHeader).catch(function(err) {
       if(typeof err.response != "undefined" && err.response.status == 401){
            Global.logout()
            sessionStorage.setItem("invalid_session_id", true)
        }
    })
    }
    /**
     * Edit channel purpose or storage node
     */
    static editChannel(channel_id, purpose){
        let data = {
            "channel_id": channel_id,
            "purpose": purpose
        }
        if(purpose.length == 0){
            data = {
                "channel_id": channel_id,
                "empty_purpose": true
            }
        }
        return axios
        .post(Global.GetAPIURL() + '/channel/edit', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static editChannelAttributes(channel_id, data){
        let values = data;
        values['channel_id'] = channel_id;

        return axios
        .post(Global.GetAPIURL() + '/channel/edit', JSON.stringify(values), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static UpdatePublic(channel_id, statue){
        let data = {
            "channel_id": channel_id,
            "public": statue,
        }
        return axios
        .post(Global.GetAPIURL() + '/channel/edit', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static delete(channel_id){
        let data = {
            "channel_id": channel_id
        }
        return axios
        .post(Global.GetAPIURL() + '/channel/delete', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static createNewStorage(channel_id, folder_id){
        let data = {
            "channel_id": channel_id,
            "folder_id": folder_id,
        }
        return axios
        .post(Global.GetAPIURL() + '/channel/create_new_storage', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static addStar(channel_id){
        let data = {
            "channel_id": channel_id,
            "action": "add",
        }
        return axios
        .post(Global.GetAPIURL() + '/channel/star', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static removeStar(channel_id){
        let data = {
            "channel_id": channel_id,
            "action": "remove",
        }
        return axios
        .post(Global.GetAPIURL() + '/channel/star', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static removeUser(channel_id, userObj){

        let data = {
            "channel_id": channel_id,
        }

        if(typeof userObj.user_id != 'undefined' && userObj.user_id.length > 0){
            data.user_id =  userObj.user_id
        }

        if(typeof userObj.invitation_id != 'undefined'){
            data.invitation_id =  userObj.invitation_id
        }

        return axios
        .post(Global.GetAPIURL() + '/channel/remove_user', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }


    static RegisterByPublicContact(channel_id, session_id){
        let data  = {
            "channel_id": channel_id
        }

        return axios
        .post(Global.GetAPIURL() + '/channel/public_contact', JSON.stringify(data),{
            headers:{
              "session_id": session_id,
            }
        }).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }


    static RTCCall(channel_id, user_ids){
        let data  = {
            "channel_id": channel_id,
            "user_ids": user_ids,
        }

        return axios
        .post(Global.GetAPIURL() + '/channel/start_call', JSON.stringify(data),sessionHeader)
    }


    static join_call(channel_id, leader_id = ''){
        let data  = {
            "channel_id": channel_id,
        }
        if(leader_id.trim().length > 0)
            data.leader_id =  leader_id

        return axios
        .post(Global.GetAPIURL() + '/channel/join_call', JSON.stringify(data),sessionHeader)
    }


    static declineCall(channel_id){
        let data  = {
            "channel_id": channel_id,
        }

        return axios
        .post(Global.GetAPIURL() + '/channel/end_call', JSON.stringify(data),sessionHeader)
    }

    static getFirstMessages(channel_ids) {
        let data = {
            channel_ids: channel_ids
        }
        return axios
        .post(Global.GetAPIURL() + '/channel/get_first_posts', JSON.stringify(data),sessionHeader)
    }

}
